"use client";

import { c as _c } from "react/compiler-runtime";
import { ProfileMinWithoutSubs } from "@/helpers/ProfileTypes";
import ProfileHandle, { ProfileHandleProps } from "@/components/common/profile/ProfileHandle";
import { ProfileBadgeSize } from "@/components/common/profile/ProfileAvatar";
import { DropPartSize } from "@/components/drops/view/part/DropPart.types";
const PROFILE_SIZE_MAP: Record<DropPartSize, ProfileBadgeSize> = {
  [DropPartSize.SMALL]: ProfileBadgeSize.SMALL,
  [DropPartSize.MEDIUM]: ProfileBadgeSize.MEDIUM,
  [DropPartSize.LARGE]: ProfileBadgeSize.LARGE
};
export default function DropAuthorHandle(t0) {
  const $ = _c(4);
  const {
    profile: t1,
    size
  } = t0;
  const {
    handle
  } = t1;
  const t2 = PROFILE_SIZE_MAP[size];
  const t3 = handle ? `/${handle}` : undefined;
  let t4;
  if ($[0] !== handle || $[1] !== t2 || $[2] !== t3) {
    const profileHandleProps = {
      handle,
      size: t2,
      href: t3
    };
    t4 = <ProfileHandle {...profileHandleProps} />;
    $[0] = handle;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
}